import { useEffect, useRef, useState } from "react";
import { fetchDateRange } from "./api";

const toYearValue = (value) =>
  typeof value === "number" && Number.isFinite(value) ? value : null;

const normalizeRange = (payload) => ({
  minYear: toYearValue(payload?.min_year),
  maxYear: toYearValue(payload?.max_year),
});

export default function useHistoryRange({ active = false } = {}) {
  const [range, setRange] = useState(null);
  const [loading, setLoading] = useState(false);
  const abortRef = useRef(null);

  useEffect(() => {
    if (!active) return;
    if (range !== null || loading) return;

    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    setLoading(true);
    console.log("[history] range fetch start");
    controller.signal.addEventListener("abort", () => {
      console.log("[history] range fetch aborted");
    });

    fetchDateRange(controller.signal)
      .then((payload) => {
        if (controller.signal.aborted) return;
        console.log("[history] range fetch success", payload);
        setRange(normalizeRange(payload));
      })
      .catch((err) => {
        if (controller.signal.aborted) return;
        console.error("Failed to load history range", err);
        setRange({ minYear: null, maxYear: null });
      })
      .finally(() => {
        if (controller.signal.aborted) return;
        setLoading(false);
      });

    return () => controller.abort();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, range]);

  useEffect(() => {
    if (!active) {
      setLoading(false);
    }
  }, [active]);

  useEffect(
    () => () => {
      abortRef.current?.abort();
    },
    []
  );

  return { range, loading };
}
